import React from "react";

type HomepageView = "calendar" | "kanban";

interface UserPreferences {
  homepageView: HomepageView;
  setHomepageView: (view: HomepageView) => void;
}

const STORAGE_KEY = "user_preferences";

const DEFAULT_PREFERENCES: { homepageView: HomepageView } = {
  homepageView: "calendar",
};

function loadPreferences(): { homepageView: HomepageView } {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      return { ...DEFAULT_PREFERENCES, ...JSON.parse(stored) };
    }
  } catch {
    // Ignore parse errors
  }
  return DEFAULT_PREFERENCES;
}

function savePreferences(prefs: { homepageView: HomepageView }) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(prefs));
}

export function useUserPreferences(): UserPreferences {
  const [preferences, setPreferences] = React.useState(() => loadPreferences());

  const setHomepageView = React.useCallback(
    (view: HomepageView) => {
      const newPrefs = { ...preferences, homepageView: view };
      setPreferences(newPrefs);
      savePreferences(newPrefs);
    },
    [preferences],
  );

  return {
    homepageView: preferences.homepageView,
    setHomepageView,
  };
}